import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { CalendarIcon, CheckIcon } from "@heroicons/react/24/outline";
import { periodOptions } from "./dateRanges";

type DateRangeSelectorProps = {
  period: string;
  onPeriodChange: (period: string) => void;
};

export default function DateRangeSelector({
  period,
  onPeriodChange,
}: DateRangeSelectorProps) {
  const selectedLabel = periodOptions.find((o) => o.value === period)!.label;

  return (
    <Popover className="order-last md:order-0 shrink-0">
      <PopoverButton
        aria-label="Filter by date"
        className="flex w-full items-center justify-center md:justify-between gap-2 rounded-xl border border-gray-200 bg-white px-2.5 md:px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
      >
        <span className="hidden md:inline truncate text-gray-950">
          {selectedLabel}
        </span>
        <CalendarIcon className="size-5 shrink-0 text-gray-500" />
      </PopoverButton>

      <PopoverPanel
        anchor={{ to: "bottom end", gap: 4 }}
        className="z-20 flex w-52 flex-col rounded-xl border border-gray-200 bg-white p-1 shadow-lg outline-none"
      >
        {({ close }) => (
          <>
            {periodOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  onPeriodChange(option.value);
                  close();
                }}
                className="flex items-center justify-between gap-2 rounded-lg px-3 py-2 text-left text-sm text-gray-950 hover:bg-blue-50 hover:text-blue-500 cursor-pointer"
              >
                {option.label}
                {period === option.value && <CheckIcon className="size-4" />}
              </button>
            ))}
          </>
        )}
      </PopoverPanel>
    </Popover>
  );
}
